import { RoleType } from './role-types';
import {
  SessionActivityTimeOfDay,
  WorkTimeType,
} from './session-activity-types';
import { SessionDayType } from './session-types';

export enum EstimateStatus {
  Draft = 'Draft',
  Final = 'Final',
}

/**
 * Rate Multipliers
 */
export type TRateMultipliers = {
  [WorkTimeType.StraightTime]: number;
  [WorkTimeType.TimeAndOneHalf]: number;
  [WorkTimeType.DoubleTime]: number;
  [WorkTimeType.NoServiceDay]: number;
  [WorkTimeType.NoServiceDayWeekendHoliday]: number;
  [SessionDayType.Saturday]: number;
  [SessionDayType.Sunday]: number;
  [SessionDayType.Holiday]: number;
  [SessionActivityTimeOfDay.Night]: number;
  [SessionActivityTimeOfDay.LateNight]: number;
  [SessionActivityTimeOfDay.AfterMidnight]: number;
  [RoleType.CopyistSideMusician1Double]: number;
  [RoleType.CopyistSideMusician2Doubles]: number;
  [RoleType.CopyistSideMusician3Doubles]: number;
  [RoleType.CopyistSideMusician4Doubles]: number;
  [multiplierType: string]: number;
};
